/**
 * Created by sunshine on 2016/12/27.
 */
/*eslint-disable*/
let apiLinks;
let ssodailyurl = window.configObject.WB_HOST;
// dev发环境 http://yc.yonyou.com 360 账号为ycwyg56
// B环境 wuyanguo 1219
// 正式环境 https://yc.yonyoucloud.com
// ================= 需要修改的部分 =================//
let yc = window.location.protocol + "//" + window.location.host;
//测试专用
// let enterpriseId = 9;
//正式专用
let enterpriseId = 1;
// 用测试专用
// let tenantid = "avxk8z2o";
// 用正式专用
let tenantid = "ccviqgye";
// 用ys_cgs测试专用
// tenantid = 'h050u1t9'
// slogan
let slogan = "";
let logourl = "static/imgs/longmeilogo1.png";
// 公司名字
let companyname = "黑龙江龙煤集团电子采购云平台";
let companyfullname = "黑龙江龙煤物流有限责任公司";
// 公司官网
// let companyHomePage = "/";
let companyHomePage = "http://www.longmaywuliu.com/indexs";
// 联系我们页面
// let companyContactUs = "";
let companyContactUs = "http://www.longmaywuliu.com/lxwm";
// 分支名字或访问context
let portaltype = "privateportal";

let bannerList = [
  {
    class: "carousel-bg-jsqp2",
  },
];
// 联系电话
let telephone = "0451-87229494  物流公司招标分公司";
let address = "北京市海淀区69号";
let servicetime = "周一至周五 上午08:30至下午17:30";
let caslogout =
  "/logout?service=" +
  encodeURIComponent(
    window.location.protocol +
      "//" +
      window.location.host +
      "/" +
      portaltype +
      "/"
  );
// let caslogout2 = "/privateportal/"
// https%3a%2f%2fu8cpur-daily.yyuap.com%2fdailytest%2f
caslogout = window.configObject.WB_HOST + "/" + caslogout
// ================= 需要修改的部分 =================//
apiLinks = {
  tenantId: tenantid,
  enterpriseId: enterpriseId,
  ssodailyurl: ssodailyurl,
  logourl: logourl,
  address: address,
  companyfullname: companyfullname,
  telephone: telephone,
  servicetime: servicetime,
  companyname: companyname,
  context: portaltype,
  bannerList: bannerList,
  slogan: slogan,
  companyContactUs: companyContactUs,
  selfHome: companyHomePage,
  welcome: "您好，欢迎来到" + companyname + "!",
  portaltype: portaltype,
  // materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
  materiaClass:
    yc +
    "/yuncai/jsonp/getMaterialClass?enterpriseId=" +
    enterpriseId +
    "&parentId=",
  orgClass:
    yc +
    "/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=" +
    enterpriseId,
  southCement: {
    home: companyHomePage,
  },
  caslogout: caslogout,
  // caslogout2:caslogout2,
  // 注册页面
  register:
    yc +
    "/cpu-portal-fe/portalcas.html#/pages/supplymgr/supplyapplyregister?purentid=" +
    enterpriseId +
    "&agree=1&ipuid=" +
    portaltype,
  // 专家注册页面
  expertregister:
    yc +
    "/cpu-portal-fe/portalcas.html#/pages/supplymgr/expertregister?purentid="+enterpriseId +
    "&agree=1&ipuid=" +
    portaltype,
  // 进入工作台/注册
  enterWorkbench: window.configObject.WB_HOST + "/login",
  //登录之后进入工作台
  enterWorkbench1: window.configObject.WB_HOST,

  // 供应商申请
  suppliersFor:
    yc +
    "/cpu-portal-fe/portalcas.html#/pages/supplymgr/addSupplyApply?purentid=" +
    enterpriseId +
    "&ipuid=" +
    portaltype +
    "&v=" +
    Date.parse(new Date().toLocaleDateString()),
  // 首页左侧数据相关链接
  infoTable: {
    latest: [
      yc +
        "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=" +
        enterpriseId +
        "&status=4&pageIndex=0&pageSize=6",
      "latest2",
      "latest3",
    ],
    area: [
      yc +
        "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=" +
        enterpriseId +
        "&status=4&pageIndex=0&pageSize=6",
      "area2",
      "area3",
      "area4",
      "area5",
      "area6",
      "area7",
      "area8",
    ],
    type: [
      yc +
        "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=" +
        enterpriseId +
        "&status=4&pageIndex=0&pageSize=6",
      "2",
      "3",
      "4",
    ],
  },
  // 物资招标公告链接(之后封装成一个对象目前只有两个)
  purchasetableDate: [
    // 询价公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=" +
      enterpriseId +
      "&status=0&pageSize=10&pageIndex=0",
    // 招标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=" +
      enterpriseId +
      "&status=4&pageSize=10&pageIndex=0",
    // 中标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=" +
      enterpriseId +
      "&status=10&pageSize=10&pageIndex=0",
    // 竞价公告
    "",
    // 竞价性谈判
    "",
  ],
  // 物流招标公告链接
  logisticstableDate: [
    // 询价公告
    "",
    // 招标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=" +
      enterpriseId +
      "&status=6&pageSize=10&pageIndex=0",
    // 中标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=" +
      enterpriseId +
      "&status=7&pageSize=10&pageIndex=0",
    // 竞价公告
    "",
    // 竞价性谈判
    "",
  ],
  // 工程招标公告链接
  logisticsestableDate: [
    // 询价公告
    "",
    // 招标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=" +
      enterpriseId +
      "&status=11&pageSize=10&pageIndex=0",
    // 中标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=" +
      enterpriseId +
      "&status=13&pageSize=10&pageIndex=0",
  ],
  // 服务招标公告链接
  engineeringtableDate: [
    // 询价公告
    "",
    // 招标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=" +
      enterpriseId +
      "&status=12&pageSize=10&pageIndex=0",
    // 中标公告
    yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=" +
      enterpriseId +
      "&status=14&pageSize=10&pageIndex=0",
  ],
  // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
  details: {
    bidDoc: yc + "/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=",
    bidDetails:
      yc + "/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=",
    bidNotice:
      yc +
      "/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=",
    bidMsg: yc + "/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=",
    bidMsg2:
      yc +
      "/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=",
    // 竞价中标通知
    bidMsg3:
      yc + "/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=",
    // 竞价公告
    bidauctionNotice:
      yc + "/cpu-bidauction-fe/bidding_Apply/index.zh_CN.html?id=",
    inquiryDetails: yc + "/cpu-fe-tender/dist/inquirydetail/index.html?id=",
    company:
      yc +
      "/cpu-portal-fe/portalcas.html#/pages/notice/noticeSystemView?roleType=3&id=",
    noticeMore:
      yc + "/cpu-dashboard-fe/index.html#/anoucementlist?tenantid=" + tenantid,
    lbnoticeMore:
      yc +
      "/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=" +
      enterpriseId +
      "&status=18",
    cqnoticeMore:
      yc +
      "/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=" +
      enterpriseId +
      "&status=19",
    lbNotice: yc + "/cpu-fe-bid/dist/lbnotice/index.html?id=", //流标公告
    cqNotice: yc + "/cpu-fe-bid/dist/clarifynotice/index.html?id=", //澄清公告
    cgNotice:  yc + '/' + portaltype + "/cgNoticesDetail.html?id=", //采购公告
    cgNoticeList:  yc + '/' + portaltype + "/noticesListOnly.html", //批次公告

  },
  notice: {
    company: "/yuncai-yop/systemnotice/portalPrivateNotice",
    bidding:
      yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=" +
      enterpriseId +
      "&status=5&pageSize=6&pageIndex=0",
    clarify: "",
    lbnotice:
      yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=" +
      enterpriseId +
      "&status=18&pageIndex=0&pageSize=6",
    cqnotice:
      yc +
      "/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=" +
      enterpriseId +
      "&status=19&pageIndex=0&pageSize=6",
  },
  // 联系我们页面
  contact:
    yc +
    "/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=" +
    enterpriseId,
  // 是否已申请过供应商
  agreement:
    yc + "/cpu-supplymgr/supplyApply/isExistApply?purEntId=" + enterpriseId,
};
export { apiLinks };



// WEBPACK FOOTER //
// ./src/api/links.js